import { render, staticRenderFns } from "./TextEllipsis.vue?vue&type=template&id=d6611776&scoped=true&"
import script from "./TextEllipsis.vue?vue&type=script&lang=ts&"
export * from "./TextEllipsis.vue?vue&type=script&lang=ts&"
import style0 from "./TextEllipsis.vue?vue&type=style&index=0&id=d6611776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6611776",
  null
  
)

export default component.exports